export default __webpack_public_path__ + "static/media/Screenshot (499).7df01c1a.png";